import React, { useEffect, useState } from "react";
import { Box, Button, Select, Stack, Text } from "@chakra-ui/react";
import { LtiContentItemSelectionForm } from "./LtiContentItemSelectionForm";
import api from "../api";
import { Toaster } from "./Toaster";
import { Loading } from "./Loading";
import { CustomizedAlert } from "./CustomizedAlert";

export const Selector = () => {
  const [courses, setCourses] = useState([]);
  const [publishes, setPublishes] = useState([]);
  const [coursesLoaded, setCoursesLoaded] = useState(false);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [loadingPublishes, setLoadingPublishes] = useState(true);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedPublishId, setSelectedPublishId] = useState(null);
  const [
    selectedPublishInstructionName,
    setSelectedPublishInstructionName,
  ] = useState("");
  const [toastConfig, setToastConfig] = useState(null);

  // Get the context.
  const url = new URL(window.location.href);

  let contentItemReturnUrl = null;
  const returnUrl = url.searchParams.get("ciru");
  if (returnUrl !== null && returnUrl !== "") {
    // Base64 decode.
    contentItemReturnUrl = atob(returnUrl);
  }

  let instructionLaunchUrl = null;
  const launchUrl = url.searchParams.get("ilu");
  if (launchUrl !== null && launchUrl !== "") {
    // Base64 decode.
    instructionLaunchUrl = atob(launchUrl);
  }

  useEffect((showToast) => {
    const fetchCourses = async () => {
      await api
        .getCourses()
        .then((response) => {
          setCourses(response.data);
          setCoursesLoaded(true);
        })
        .catch(() => {
          showToast({
            title: "Error",
            description: "An error has occurred retrieving the Check courses.",
            position: "top",
            status: "error",
            duration: null,
            isClosable: false,
          });
        })
        .finally(() => {
          setLoadingCourses(false);
        });
    };

    fetchCourses();
  }, []);

  async function showToast(config) {
    setToastConfig(config);
  }

  async function handleCourseChange(courseId, courseName) {
    setSelectedPublishId(null);
    setSelectedCourseId(courseId);
    setSelectedCourseName(courseName);

    if (
      courseId !== "" &&
      Number.isInteger(Number(courseId) && Number(courseId)) > 0
    ) {
      setLoadingPublishes(true);

      await api
        .getCoursePublishes(courseId)
        .then((response) => {
          setPublishes(response.data);
        })
        .catch(() => {
          showToast({
            title: "Error",
            description:
              "An error has occurred retrieving the Check instructions.",
            position: "top",
            status: "error",
            duration: null,
            isClosable: false,
          });
        })
        .finally(() => {
          setLoadingPublishes(false);
        });
    }
  }

  function handlePublishChange(publishId, instructionName) {
    setSelectedPublishId(publishId);
    setSelectedPublishInstructionName(instructionName);
  }

  const courseSelection = !coursesLoaded ? (
    loadingCourses ? (
      <Loading />
    ) : (
      ""
    )
  ) : (
    <Box>
      <Text fontSize="lg">Check Courses</Text>
      <Select
        placeholder="-- Select --"
        onChange={(e) =>
          handleCourseChange(
            e.target.value,
            e.target.options[e.target.selectedIndex].text
          )
        }
      >
        {courses.map((course) => (
          <option key={course.id} value={course.id}>
            {course.name}
          </option>
        ))}
      </Select>
    </Box>
  );

  const publishSelection =
    !loadingPublishes &&
    selectedCourseId !== "" &&
    Number.isInteger(Number(selectedCourseId)) &&
    Number(selectedCourseId) > 0 ? (
      <Box>
        <Text fontSize="lg">{selectedCourseName} Instructions</Text>
        <Select
          placeholder="-- Select --"
          onChange={(e) =>
            handlePublishChange(
              e.target.value,
              e.target.options[e.target.selectedIndex].text
            )
          }
        >
          {publishes.map((publish) => (
            <option key={publish.id} value={publish.id}>
              {publish.instructionName}
            </option>
          ))}
        </Select>
      </Box>
    ) : (
      ""
    );

  const formSubmission =
    selectedCourseId !== "" &&
    Number.isInteger(Number(selectedCourseId)) &&
    Number(selectedCourseId) > 0 &&
    selectedPublishId !== null &&
    selectedPublishId !== "" ? (
      <LtiContentItemSelectionForm
        contentItemReturnUrl={contentItemReturnUrl}
        launchId={instructionLaunchUrl}
        launchUrl={instructionLaunchUrl + "?pid=" + selectedPublishId}
        title="Check"
        text="Check"
        displayHeight="500"
        displayWidth="100%"
      >
        <Button colorScheme="green" type="submit">
          Insert {selectedPublishInstructionName}
        </Button>
      </LtiContentItemSelectionForm>
    ) : (
      ""
    );

  return (
    <Box>
      <CustomizedAlert
        status="info"
        text="Select a Check instruction to insert."
      />
      <Stack spacing={4} mt={4}>
        <Box>{courseSelection}</Box>
        <Box>{publishSelection}</Box>
        <Box>{formSubmission}</Box>
      </Stack>
      <Toaster toastConfig={toastConfig} />
    </Box>
  );
};
